(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mahjverse-faq"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const navigationEntry = performance.getEntriesByType('navigation')[0];
    const isReloadNavigation = navigationEntry?.type === 'reload';

    document.querySelectorAll('[data-newsletter-form]').forEach((form) => {
      if (form.dataset.newsletterReady === 'true') return;
      form.dataset.newsletterReady = 'true';

      const button = form.querySelector('[data-newsletter-submit]');
      const label = form.querySelector('[data-newsletter-submit-label]');
      let resetTimer;

      const reset = () => {
        window.clearTimeout(resetTimer);
        form.removeAttribute('aria-busy');
        form.classList.remove('is-submitting');
        if (button) button.disabled = false;
        if (label) label.textContent = 'SUBSCRIBE';
      };

      form.addEventListener('submit', (event) => {
        if (!form.checkValidity()) return;
        if (form.getAttribute('aria-busy') === 'true') {
          event.preventDefault();
          return;
        }

        if (document.querySelector('[data-scroll-hero]')) {
          try {
            sessionStorage.setItem('mj-home-newsletter-return', JSON.stringify({ y: window.scrollY, at: Date.now() }));
          } catch (error) {}
        }

        form.setAttribute('aria-busy', 'true');
        form.classList.add('is-submitting');
        if (button) button.disabled = true;
        if (label) label.textContent = 'SUBSCRIBING…';
        resetTimer = window.setTimeout(reset, 12000);
      });

      window.addEventListener('pageshow', reset);
      if (isReloadNavigation) {
        form.querySelectorAll('.mj-footer__message--success').forEach((message) => message.remove());
      }
      const result = form.querySelector('[data-newsletter-result]');
      if (result && !isReloadNavigation) window.requestAnimationFrame(() => result.focus({ preventScroll: false }));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mahjverse-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

    document.querySelectorAll('[data-scroll-hero]').forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';

      const video = root.querySelector('[data-scroll-video]');
      const copy = root.querySelector('.mj-hero__copy');
      const decorations = root.querySelectorAll('.mj-hero__note-left, .mj-hero__script, .mj-hero__note-right');
      const cta = root.querySelector('.mj-hero__cta');
      const announcement = root.querySelector('.mj-hero__announcement');
      const header = root.querySelector('.mj-hero__header');
      const heroWindow = root.querySelector('.mj-hero__window');
      const mobileMenu = root.querySelector('[data-mobile-menu]');
      const mobileMenuToggle = root.querySelector('[data-mobile-menu-toggle]');
      const searchPanel = root.querySelector('[data-search-panel]');
      const searchShell = root.querySelector('[data-search-shell]');
      const searchToggle = root.querySelector('[data-search-toggle]');
      const searchForm = root.querySelector('[data-search-form]');
      const searchInput = root.querySelector('[data-search-input]');
      const cartShell = root.querySelector('[data-cart-shell]');
      const cartToggle = root.querySelector('[data-cart-toggle]');
      const cartPopover = root.querySelector('[data-cart-popover]');
      const cartItems = root.querySelector('[data-cart-items]');
      const cartFooter = root.querySelector('[data-cart-footer]');
      const cartTotal = root.querySelector('[data-cart-total]');
      const cartReferenceTotal = root.querySelector('[data-cart-reference-total]');
      const backToTop = root.querySelector('[data-back-to-top]');
      const language = root.querySelector('.mj-language');
      const languageToggle = language?.querySelector('button');
      function closeLanguage() { language?.classList.remove('is-open'); languageToggle?.setAttribute('aria-expanded', 'false'); }
      const alignPopover = () => {
        const anchors = [cartToggle, languageToggle].filter(Boolean);
        const top = anchors.reduce((sum, anchor) => sum + anchor.getBoundingClientRect().bottom, 0) / Math.max(1, anchors.length) + 8;
        for (const [panel, anchor] of [[cartPopover, cartToggle], [root.querySelector('.mj-language__menu'), root.querySelector('.mj-language__toggle')]]) {
          if (!panel?.offsetParent || !anchor) continue;
          const parent = panel.offsetParent.getBoundingClientRect();
          const button = anchor.getBoundingClientRect();
          const left = Math.max(12, Math.min(button.right - panel.offsetWidth, window.innerWidth - panel.offsetWidth - 12));
          panel.style.left = (left - parent.left) + 'px';
          panel.style.right = 'auto';
          panel.style.top = (top - parent.top) + 'px';
        }
      };
      const popoverResizeObserver = new ResizeObserver(alignPopover);
      popoverResizeObserver.observe(header);
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let headerFlipToken = 0;
      let headerFlipTimer = 0;
      const clearHeaderFlip = () => {
        headerFlipToken += 1;
        window.clearTimeout(headerFlipTimer);
        headerFlipTimer = 0;
        header.style.setProperty('transition', 'none');
        header.style.setProperty('--mj-header-flip-x', '0px');
        header.style.setProperty('--mj-header-flip-y', '0px');
        header.style.setProperty('--mj-header-flip-scale-x', '1');
        header.style.setProperty('--mj-header-flip-scale-y', '1');
        header.style.removeProperty('will-change');
        header.offsetWidth;
        header.style.removeProperty('transition');
        header.style.removeProperty('--mj-header-flip-x');
        header.style.removeProperty('--mj-header-flip-y');
        header.style.removeProperty('--mj-header-flip-scale-x');
        header.style.removeProperty('--mj-header-flip-scale-y');
      };
      const setHeaderCompact = (compact) => {
        const next = Boolean(compact);
        if (header.classList.contains('is-compact') === next) return;
        clearHeaderFlip();
        const before = header.getBoundingClientRect();
        header.classList.toggle('is-compact', next);
        const after = header.getBoundingClientRect();
        if (reducedMotion.matches || !before.width || !after.width) {
          alignPopover();
          return;
        }
        const beforeCenterX = before.left + before.width / 2;
        const beforeCenterY = before.top + before.height / 2;
        const afterCenterX = after.left + after.width / 2;
        const afterCenterY = after.top + after.height / 2;
        const runToken = ++headerFlipToken;
        header.style.setProperty('transition', 'none');
        header.style.setProperty('--mj-header-flip-x', (beforeCenterX - afterCenterX) + 'px');
        header.style.setProperty('--mj-header-flip-y', (beforeCenterY - afterCenterY) + 'px');
        header.style.setProperty('--mj-header-flip-scale-x', String(before.width / after.width));
        header.style.setProperty('--mj-header-flip-scale-y', String(before.height / after.height));
        header.style.setProperty('will-change', 'transform');
        header.offsetWidth;
        header.style.removeProperty('transition');
        requestAnimationFrame(() => {
          if (runToken !== headerFlipToken) return;
          header.style.setProperty('--mj-header-flip-x', '0px');
          header.style.setProperty('--mj-header-flip-y', '0px');
          header.style.setProperty('--mj-header-flip-scale-x', '1');
          header.style.setProperty('--mj-header-flip-scale-y', '1');
          headerFlipTimer = window.setTimeout(() => {
            if (runToken !== headerFlipToken) return;
            header.style.removeProperty('--mj-header-flip-x');
            header.style.removeProperty('--mj-header-flip-y');
            header.style.removeProperty('--mj-header-flip-scale-x');
            header.style.removeProperty('--mj-header-flip-scale-y');
            header.style.removeProperty('will-change');
            headerFlipTimer = 0;
            alignPopover();
          }, 240);
        });
      };
      const mobileLayout = window.matchMedia('(max-width: 749px)');
      const lowPowerDevice = !mobileLayout.matches && ((navigator.hardwareConcurrency || 8) <= 4 || (navigator.deviceMemory || 8) <= 4 || navigator.connection?.saveData || /(^|-)2g$|3g/.test(navigator.connection?.effectiveType || ''));
      const heroScrubFrameRate = lowPowerDevice ? 30 : 60;
      const controller = new AbortController();
      document.documentElement.classList.toggle('mj-low-power', lowPowerDevice);
      languageToggle?.addEventListener('click', () => {
        if (language.classList.contains('is-open')) { closeLanguage(); return; }
        closeCart();
        alignPopover();
        language.classList.add('is-open');
        languageToggle.setAttribute('aria-expanded', 'true');
      }, { signal: controller.signal });
      cartToggle?.addEventListener('click', alignPopover, { signal: controller.signal });
      window.addEventListener('resize', alignPopover, { passive: true, signal: controller.signal });
      let duration = 0;
      let targetTime = 0;
      let raf = 0;
      let needsMeasure = true;
      let objectUrl = '';
      let videoFrameVisible = false;
      let videoFrameRevealPending = false;
      let sectionFrame = 0;
      let sectionTransitioning = false;
      let sectionDirection = 0;
      let sectionRunToken = 0;
      let heroCovered = false;
      let productsVisited = false;
      let returningFromProducts = false;
      let returnStartScrollTop = 0;
      let returnStartHeight = 0;
      let returnRootTop = 0;
      let lastHeroScrollTop = window.scrollY;
      let topReturnActive = false;
      let searchCloseTimer = 0;
      let cachedSectionMetrics = null;
      let scrollbarDragActive = false;
      let scrollbarReleaseTimer = 0;
      let lastVideoSeekAt = 0;
      let sectionResizeObserver = null;
      let backToTopNudgeAnimation = null;
      let bottomNudgeTouchY = 0;
      let reconcileNativePosition = () => {};
      let nativePositionRestoreActive = false;
      let nativePositionRestoreTimer = 0;
      let restoreTop = null;

      const jumpToScrollTop = (top) => {
        const scrollingElement = document.scrollingElement || document.documentElement;
        scrollingElement.scrollTop = top;
      };

      const syncProductEntryState = (active) => {
        document.documentElement.classList.toggle('mj-products-entering', active && !mobileLayout.matches);
      };

      const emitHomeEvent = (name) => {
        if (window.MahjverseHomeScroll) window.MahjverseHomeScroll.emit(name);
        else window.dispatchEvent(new CustomEvent(`mj:${name}`));
      };

      const addHomepageInputListener = (type, listener, options) => {
        if (window.MahjverseHomeScroll?.subscribeInput) {
          window.MahjverseHomeScroll.subscribeInput(type, listener, { signal: controller.signal });
          return;
        }
        window.addEventListener(type, listener, { ...options, signal: controller.signal });
      };

      const setProductsOperable = (active) => {
        const isOperable = Boolean(active);
        const wasOperable = document.documentElement.classList.contains('mj-products-operable');
        document.documentElement.classList.toggle('mj-products-operable', isOperable);
        if (isOperable && !wasOperable) emitHomeEvent('products-ready');
      };

      const isScrollbarEdge = (event) => {
        const scrollbarWidth = Math.max(0, window.innerWidth - document.documentElement.clientWidth);
        return scrollbarWidth > 0 && event.clientX >= document.documentElement.clientWidth;
      };

      const isScrollbarArrow = (event) => {
        const scrollbarWidth = Math.max(0, window.innerWidth - document.documentElement.clientWidth);
        const arrowSize = Math.max(18, scrollbarWidth);
        return event.clientY <= arrowSize || event.clientY >= window.innerHeight - arrowSize;
      };

      const isAtPageBottom = () => {
        const scrollingElement = document.scrollingElement || document.documentElement;
        return window.scrollY + window.innerHeight >= scrollingElement.scrollHeight - 2;
      };

      const nudgeBackToTop = () => {
        if (!backToTop?.classList.contains('is-visible') || reducedMotion.matches) return;
        if (backToTopNudgeAnimation?.playState === 'running') return;
        backToTopNudgeAnimation = backToTop.animate([
          { translate: '0 0', scale: '1 1', offset: 0 },
          { translate: '0 -7px', scale: '.985 1.035', offset: .38 },
          { translate: '0 2px', scale: '1.012 .99', offset: .72 },
          { translate: '0 0', scale: '1 1', offset: 1 }
        ], {
          duration: 420,
          easing: 'cubic-bezier(.22,.61,.36,1)'
        });
        backToTopNudgeAnimation.finished.catch(() => null).finally(() => {
          backToTopNudgeAnimation = null;
        });
      };

      const setScrollbarDrag = (active) => {
        scrollbarDragActive = Boolean(active);
        document.documentElement.classList.toggle('mj-scrollbar-dragging', scrollbarDragActive);
        emitHomeEvent(scrollbarDragActive ? 'scrollbar-drag-start' : 'scrollbar-drag-end');
        if (!scrollbarDragActive) return;
        restoreTop = null;
        nativePositionRestoreActive = false;
        window.clearTimeout(nativePositionRestoreTimer);
        document.documentElement.classList.remove('mj-restoring-position');
        if ('scrollRestoration' in history) history.scrollRestoration = 'auto';
        if (returningFromProducts) setReturningFromProducts(false);
        sectionTransitioning = false;
        syncProductEntryState(false);
        setProductsOperable(false);
      };

      const invalidateSectionMetrics = () => {
        cachedSectionMetrics = null;
      };

            const getSectionMetrics = (refresh = false) => {
        if (cachedSectionMetrics && !refresh) return cachedSectionMetrics;
        const products = document.querySelector('#mahjverse-products');
        if (!products) return null;
        const rootTop = root.getBoundingClientRect().top + window.scrollY;
        const productsTop = products.getBoundingClientRect().top + window.scrollY;
        const productsStage = products.querySelector('.mj-products__stage');
        const frameInset = productsStage ? Math.max(0, parseFloat(getComputedStyle(productsStage).top) || 0) : 0;
        const productInset = mobileLayout.matches ? 0 : Math.max(1, Number(products.dataset.scrollInset) || 2);
        const productsStart = (mobileLayout.matches ? Math.round(productsTop) : Math.ceil(productsTop)) + productInset;
        cachedSectionMetrics = {
          rootTop,
          productsTop,
          productsStart,
          heroRevealStart: productsTop - frameInset,
          productsEnd: Math.max(productsStart, Math.floor(productsTop + products.offsetHeight - window.innerHeight) - productInset),
          heroEnd: Math.max(rootTop, productsTop - window.innerHeight)
        };
        return cachedSectionMetrics;
      };


      const resetCoveredHero = (metrics) => {
        if (!metrics || heroCovered) return metrics;
        heroCovered = true;
        targetTime = duration;
        if (video.readyState >= 1) video.currentTime = duration;
        return metrics;
      };

      const syncHeroReturnGeometry = (scrollTop) => {
        if (!returningFromProducts || mobileLayout.matches || returnStartHeight <= 0) return;
        const returnDistance = Math.max(1, returnStartScrollTop - returnRootTop);
        const returnProgress = clamp((returnStartScrollTop - scrollTop) / returnDistance, 0, 1);
        const targetHeight = Math.max(1, window.innerHeight);
        const nextHeight = targetHeight + (returnStartHeight - targetHeight) * (1 - returnProgress);
        const currentHeight = root.getBoundingClientRect().height;
        if (Math.abs(nextHeight - currentHeight) < .5) return;
        root.style.height = `${nextHeight}px`;
        root.offsetHeight;
        invalidateSectionMetrics();
        emitHomeEvent('hero-geometry-changed');
      };

      const setReturningFromProducts = (active) => {
        const next = Boolean(active);
        if (returningFromProducts === next) return;
        returningFromProducts = next;
        root.classList.toggle('is-returning-first-frame', next);
        if (!next) {
          const hadReturnHeight = root.style.height !== '';
          root.style.removeProperty('height');
          returnStartScrollTop = 0;
          returnStartHeight = 0;
          returnRootTop = 0;
          if (hadReturnHeight) {
            root.offsetHeight;
            invalidateSectionMetrics();
            emitHomeEvent('hero-geometry-changed');
          }
          return;
        }
        returnStartScrollTop = window.scrollY;
        returnStartHeight = root.getBoundingClientRect().height;
        returnRootTop = root.getBoundingClientRect().top + window.scrollY;
        heroCovered = false;
        targetTime = 0;
        video.pause();
        if (video.readyState >= 1 && video.currentTime > 0.002) video.currentTime = 0;
      };

      const completeHeroReturnAtTop = (metrics) => {
        const top = Math.max(0, returnRootTop || metrics.rootTop);
        if (window.scrollY > top + 1) return;
        productsVisited = false;
        setReturningFromProducts(false);
        heroCovered = false;
        targetTime = 0;
        lastHeroScrollTop = window.scrollY;
        if (video.readyState >= 1 && video.currentTime > 0.002) video.currentTime = 0;
      };

      const syncHeroJourney = (scrollTop, metrics) => {
        if (!metrics) return;
        if (scrollbarDragActive) {
          lastHeroScrollTop = scrollTop;
          return;
        }
        // The product gate owns scrolling while its video opens and advances.
        // Treat those scroll events as position updates, not a return to the hero.
        if (document.documentElement.classList.contains('mj-products-video-playing')) {
          lastHeroScrollTop = scrollTop;
          return;
        }
        const movingUp = scrollTop < lastHeroScrollTop - .5;
        const movingDown = scrollTop > lastHeroScrollTop + .5;
        const productAtStart = document.documentElement.classList.contains('mj-products-at-start');
        if (scrollTop >= metrics.productsStart - 2) {
          productsVisited = true;
        }
        if (productsVisited && movingUp && scrollTop <= metrics.productsEnd + 2 && productAtStart) {
          setReturningFromProducts(true);
        } else if (returningFromProducts && movingDown && scrollTop >= returnStartScrollTop - 2) {
          setReturningFromProducts(false);
        }
        if (returningFromProducts) syncHeroReturnGeometry(scrollTop);
        const returnTopThreshold = (returnRootTop || metrics.rootTop) + 1;
        if (returningFromProducts && movingUp && scrollTop <= returnTopThreshold) {
          completeHeroReturnAtTop(metrics);
          return;
        }
        lastHeroScrollTop = window.scrollY;
      };

      const cancelSectionTransition = () => {
        sectionRunToken += 1;
        if (sectionFrame) cancelAnimationFrame(sectionFrame);
        sectionFrame = 0;
        sectionTransitioning = false;
        sectionDirection = 0;
        heroCovered = false;
        root.classList.remove('is-cta-transitioning');
        cta?.removeAttribute('disabled');
        syncProductEntryState(false);
        setProductsOperable(false);
        invalidateSectionMetrics();
        update();
      };

      const animateScrollTo = (destination, durationMs, onComplete, curvePower = 4) => {
        if (sectionFrame) cancelAnimationFrame(sectionFrame);
        const runToken = ++sectionRunToken;
        sectionTransitioning = true;
        const start = window.scrollY;
        const distance = destination - start;
        sectionDirection = Math.sign(distance);
        const startedAt = performance.now();
        const step = (now) => {
          if (runToken !== sectionRunToken || !sectionTransitioning) {
            sectionFrame = 0;
            return;
          }
          const progress = clamp((now - startedAt) / durationMs, 0, 1);
          const eased = 1 - Math.pow(1 - progress, curvePower);
          const nextTop = start + distance * eased;
          const arrived = progress >= 1 || Math.abs(destination - nextTop) <= 2;
          window.scrollTo({ left: window.scrollX, top: arrived ? destination : nextTop, behavior: 'auto' });
          if (!arrived) {
            sectionFrame = requestAnimationFrame(step);
            return;
          }
          sectionFrame = 0;
          sectionDirection = 0;
          if (onComplete) {
            onComplete();
          } else {
            sectionTransitioning = false;
          }
        };
        sectionFrame = requestAnimationFrame(step);
      };

      const returnToTop = (metrics) => {
        if (topReturnActive) return;
        topReturnActive = true;
        productsVisited = false;
        setReturningFromProducts(true);
        heroCovered = false;
        invalidateSectionMetrics();
        document.documentElement.classList.add('mj-top-returning');
        emitHomeEvent('top-return-start');

        sectionTransitioning = false;
        syncProductEntryState(false);
        setProductsOperable(false);
        backToTop?.setAttribute('disabled', '');
        if (sectionFrame) cancelAnimationFrame(sectionFrame);
        sectionFrame = 0;
        root.classList.remove('is-cta-transitioning');
        cta?.removeAttribute('disabled');
        targetTime = 0;
        jumpToScrollTop(metrics.rootTop);
        if (video.readyState >= 1 && video.currentTime > 0.002) video.currentTime = 0;
        heroCovered = false;
        sectionTransitioning = false;
        targetTime = 0;
        lastVideoSeekAt = 0;
        invalidateSectionMetrics();
        topReturnActive = false;
        setReturningFromProducts(false);
        document.documentElement.classList.remove('mj-top-returning');
        backToTop?.removeAttribute('disabled');
        update();
      };

      const completeProductEntry = (metrics) => {
        metrics = resetCoveredHero(metrics);
        productsVisited = true;
        targetTime = duration;
        if (video.readyState >= 1 && Math.abs(video.currentTime - duration) > 0.002) video.currentTime = duration;
        sectionTransitioning = false;
        syncProductEntryState(false);
        setProductsOperable(true);

        jumpToScrollTop(metrics.productsStart);
        lastHeroScrollTop = metrics.productsStart;
        update();

      };

      const enterProductsFromCta = (metrics) => {
        if (!metrics || sectionTransitioning) return;
        heroCovered = true;
        targetTime = duration;
        if (video.readyState >= 1) video.currentTime = duration;
        setProductsOperable(false);
        syncProductEntryState(true);
        root.classList.add('is-cta-transitioning');
        cta?.setAttribute('disabled', '');

        const distance = Math.abs(metrics.productsStart - window.scrollY);
        const transitionDuration = clamp(500 + distance * .045, 560, 780);
        animateScrollTo(metrics.productsStart, transitionDuration, () => {
          root.classList.remove('is-cta-transitioning');
          cta?.removeAttribute('disabled');
          completeProductEntry(metrics);
        }, 2.6);
      };

      const measure = () => {
        let metrics = getSectionMetrics();
        if (metrics) {
          syncHeroJourney(window.scrollY, metrics);
          metrics = getSectionMetrics();
        }
        const rootTop = metrics?.rootTop ?? (root.getBoundingClientRect().top + window.scrollY);
        const distance = Math.max(1, root.offsetHeight - window.innerHeight);
        const progress = clamp((window.scrollY - rootTop) / distance, 0, 1);
        const easedProgress = Math.sqrt(progress);
        const exitOffset = Math.max(0, window.scrollY - rootTop - distance);
        const productReveal = metrics
          ? clamp((window.scrollY - metrics.heroEnd) / Math.max(1, metrics.productsTop - metrics.heroEnd), 0, 1)
          : 0;
        const heroRetreat = returningFromProducts && metrics
          ? clamp((window.scrollY - metrics.rootTop) / Math.max(1, metrics.productsStart - metrics.rootTop), 0, 1)
          : productReveal;
        const stage = root.querySelector('.mj-hero__stage');
        if (reducedMotion.matches) {
          heroWindow?.style.setProperty('--mj-hero-retreat', '0');
          stage.style.setProperty('--mj-hero-retreat', '0');
          heroWindow?.classList.remove('is-retreating');
          stage.style.transform = 'none';
          stage.style.visibility = 'visible';
          stage.style.opacity = '1';
          copy.style.opacity = '1';
          copy.style.transform = 'none';
          decorations.forEach((element) => { element.style.opacity = '1'; });
          cta.style.opacity = '1';
          cta.style.transform = 'none';
          announcement?.style.setProperty('opacity', '1');
          announcement?.style.setProperty('transform', 'none');
          setHeaderCompact(productReveal > 0.06);
          const showBackToTop = metrics ? window.scrollY >= metrics.productsStart - 2 : progress >= 0.995;
          backToTop?.classList.toggle('is-visible', showBackToTop);
          backToTop?.setAttribute('aria-hidden', String(!showBackToTop));
          if (backToTop) backToTop.tabIndex = showBackToTop ? 0 : -1;
          return;
        }
        heroWindow?.style.setProperty('--mj-hero-retreat', String(heroRetreat));
        stage.style.setProperty('--mj-hero-retreat', String(heroRetreat));
        heroWindow?.classList.toggle('is-retreating', heroRetreat > 0.001);
        stage.style.removeProperty('transform');
        const heroExposed = metrics ? window.scrollY < metrics.heroRevealStart : exitOffset < window.innerHeight;
        stage.style.visibility = heroExposed ? 'visible' : 'hidden';
        stage.style.opacity = heroExposed ? '1' : '0';

        const holdTailFrame = heroCovered && !returningFromProducts;
        const holdFirstFrame = topReturnActive || returningFromProducts;
        const returnProgress = holdFirstFrame ? 0 : null;
        targetTime = holdTailFrame ? duration : holdFirstFrame ? 0 : duration * easedProgress;
        const interfaceExit = returningFromProducts
          ? clamp((heroRetreat - .68) / .16, 0, 1)
          : returnProgress === null
            ? clamp((progress - 0.82) / 0.06, 0, 1)
            : returnProgress;
        copy.style.opacity = String(1 - interfaceExit);
        copy.style.transform = `translate3d(0, ${interfaceExit * -18}px, 0)`;
        decorations.forEach((element) => { element.style.opacity = String(1 - interfaceExit); });
        cta.style.opacity = String(1 - interfaceExit);
        cta.style.transform = `translate3d(${interfaceExit * 120}vw, 0, 0)`;
        if (announcement) {
          announcement.style.opacity = String(1 - interfaceExit);
          announcement.style.transform = `translate3d(0, ${interfaceExit * 100}%, 0) scaleY(${1 - interfaceExit})`;
        }
        setHeaderCompact(heroRetreat > 0.04);
        const showBackToTop = metrics ? window.scrollY >= metrics.productsStart - 2 : progress >= 0.995;
        backToTop?.classList.toggle('is-visible', showBackToTop);
        backToTop?.setAttribute('aria-hidden', String(!showBackToTop));
        if (backToTop) backToTop.tabIndex = showBackToTop ? 0 : -1;
      };

      const render = () => {
        raf = 0;
        if (needsMeasure) {
          needsMeasure = false;
          measure();
        }
        if (!duration || reducedMotion.matches) return;
        if (video.seeking) {
          raf = requestAnimationFrame(render);
          return;
        }

        const delta = targetTime - video.currentTime;
        const now = performance.now();
        const seekInterval = 1000 / heroScrubFrameRate;
        if (Math.abs(delta) > 0.002 && now - lastVideoSeekAt >= seekInterval) {
          const frameStep = 1 / heroScrubFrameRate;
          const adaptiveStep = Math.min(Math.abs(delta), Math.max(frameStep, Math.abs(delta) * .82));
          lastVideoSeekAt = now;
          video.currentTime = clamp(video.currentTime + Math.sign(delta) * adaptiveStep, 0, duration);
        }

        if (!video.seeking && Math.abs(targetTime - video.currentTime) > 0.002) raf = requestAnimationFrame(render);
      };

      const update = () => {
        needsMeasure = true;
        if (!raf) raf = requestAnimationFrame(render);
      };

      const revealVideoFrame = () => {
        if (videoFrameVisible || videoFrameRevealPending) return;
        videoFrameRevealPending = true;
        const commit = () => {
          videoFrameRevealPending = false;
          if (controller.signal.aborted) return;
          videoFrameVisible = true;
          root.classList.add('is-video-ready');
        };
        if ('requestVideoFrameCallback' in video) {
          video.requestVideoFrameCallback(commit);
        } else {
          requestAnimationFrame(commit);
        }
      };

      const closeCart = () => {
        if (!cartPopover || !cartToggle) return;
        cartPopover.classList.remove('is-open');
        cartPopover.setAttribute('aria-hidden', 'true');
        cartPopover.setAttribute('inert', '');
        cartToggle.setAttribute('aria-expanded', 'false');
      };

      const openCart = () => {
        if (!cartPopover || !cartToggle) return;
        closeMobileMenu();
        closeSearch(true);
        closeLanguage();
        cartPopover.classList.add('is-open');
        cartPopover.setAttribute('aria-hidden', 'false');
        cartPopover.removeAttribute('inert');
        cartToggle.setAttribute('aria-expanded', 'true');
      };

      const formatCartMoney = (cents, currency) => {
        try {
          return new Intl.NumberFormat(document.documentElement.lang || 'en', {
            style: 'currency',
            currency: currency || cartPopover?.dataset.currency || 'USD'
          }).format(Number(cents || 0) / 100);
        } catch (error) {
          return `$${(Number(cents || 0) / 100).toFixed(2)}`;
        }
      };

      const renderCart = (cart, referenceTotal) => {
        if (!cartPopover || !cartItems || !cartFooter || !cartTotal || !cartReferenceTotal) return;
        const labels = cartPopover.dataset;
        cartToggle?.classList.toggle('has-items', Boolean(cart?.items?.length));
        cartItems.replaceChildren();
        if (!cart?.items?.length) {
          const empty = document.createElement('div');
          const message = document.createElement('p');
          const shopLink = document.createElement('a');
          empty.className = 'mj-cart-popover__empty';
          message.textContent = labels.emptyLabel;
          shopLink.href = labels.shopUrl;
          shopLink.textContent = labels.shopLabel;
          empty.append(message, shopLink);
          cartItems.append(empty);
          cartFooter.classList.add('is-empty');
          return;
        }
        const currency = cart.currency || labels.currency;
        cart.items.forEach((item) => {
          const link = document.createElement('a');
          const image = document.createElement('img');
          const copy = document.createElement('span');
          const title = document.createElement('strong');
          const meta = document.createElement('small');
          link.className = 'mj-cart-popover__item-link';
          link.href = item.url;
          image.src = item.image || '';
          image.alt = item.product_title || '';
          image.width = 56;
          image.height = 56;
          image.loading = 'lazy';
          copy.className = 'mj-cart-popover__item-copy';
          title.textContent = item.product_title || '';
          meta.textContent = `${item.quantity} × ${formatCartMoney(item.final_price, currency)}`;
          copy.append(title, meta);
          if (item.image) link.append(image);
          link.append(copy);
          const row = document.createElement('div');
          row.className = 'mj-cart-popover__item';
          const remove = document.createElement('button');
          remove.type = 'button';
          remove.className = 'mj-cart-popover__remove';
          remove.dataset.cartRemoveLine = item.key;
          remove.setAttribute('aria-label', 'Remove ' + (item.product_title || 'item'));
          remove.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13M10 11v6m4-6v6"/></svg>';
          row.append(link, remove);
          cartItems.append(row);
        });
        const resolvedReferenceTotal = Math.max(
          Number(cart.total_price) || 0,
          Number(referenceTotal ?? labels.referenceTotal) || 0
        );
        labels.referenceTotal = String(resolvedReferenceTotal);
        cartReferenceTotal.textContent = formatCartMoney(resolvedReferenceTotal, currency);
        cartTotal.textContent = formatCartMoney(cart.total_price, currency);
        cartFooter.classList.remove('is-empty');
      };

      let removingCartItem = false;
      cartPopover?.addEventListener('click', async (event) => {
        const button = event.target.closest('[data-cart-remove-line]');
        if (!button) return;
        event.preventDefault();
        event.stopPropagation();
        if (removingCartItem) return;
        removingCartItem = true;
        button.disabled = true;
        try {
          const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/change.js', {
            method: 'POST', credentials: 'same-origin',
            headers: {'Content-Type':'application/json'},
            body: JSON.stringify({id: button.dataset.cartRemoveLine, quantity: 0})
          });
          if (!response.ok) throw new Error('Unable to remove item. Please try again.');
          const cart = await response.json();
          renderCart(cart, cart.original_total_price);
          const count = root.querySelector('[data-cart-count]');
          if (count) {
            count.textContent = String(cart.item_count);
            count.dataset.count = String(cart.item_count);
            count.classList.toggle('is-empty', cart.item_count === 0);
          }
        } catch (error) {
          window.alert(error.message);
        } finally {
          removingCartItem = false;
          button.disabled = false;
        }
      }, {signal: controller.signal});

      const closeMobileMenu = () => {
        if (!mobileMenu || !mobileMenuToggle) return;
        mobileMenu.classList.remove('is-open');
        mobileMenu.setAttribute('aria-hidden', 'true');
        mobileMenu.setAttribute('inert', '');
        mobileMenuToggle.setAttribute('aria-expanded', 'false');
      };

      const finishSearchClose = () => {
        if (searchPanel && !searchPanel.classList.contains('is-open')) {
          searchPanel.classList.remove('is-closing');
          header.classList.remove('is-search-open');
        }
        searchCloseTimer = 0;
      };

      const closeSearch = (immediate = false) => {
        if (!searchPanel || !searchToggle) return;
        window.clearTimeout(searchCloseTimer);
        searchPanel.setAttribute('aria-hidden', 'true');
        searchToggle.setAttribute('aria-expanded', 'false');
        if (immediate || reducedMotion.matches) {
          searchPanel.classList.remove('is-open', 'is-closing');
          header.classList.remove('is-search-open');
          searchCloseTimer = 0;
          return;
        }
        searchPanel.classList.add('is-closing');
        searchPanel.classList.remove('is-open');
        searchCloseTimer = window.setTimeout(finishSearchClose, 160);
      };

      const openSearch = () => {
        if (!searchPanel || !searchToggle || !searchInput) return;
        window.clearTimeout(searchCloseTimer);
        searchCloseTimer = 0;
        closeCart();
        searchPanel.classList.remove('is-closing');
        closeMobileMenu();
        closeLanguage();
        header.classList.add('is-search-open');
        searchPanel.classList.add('is-open');
        searchPanel.setAttribute('aria-hidden', 'false');
        searchToggle.setAttribute('aria-expanded', 'true');
        requestAnimationFrame(() => searchInput.focus());
      };

      const openMobileMenu = () => {
        if (!mobileMenu || !mobileMenuToggle) return;
        closeCart();
        closeSearch(true);
        closeLanguage();
        mobileMenu.classList.add('is-open');
        mobileMenu.setAttribute('aria-hidden', 'false');
        mobileMenu.removeAttribute('inert');
        mobileMenuToggle.setAttribute('aria-expanded', 'true');
      };

      mobileMenuToggle?.addEventListener('click', () => {
        if (mobileMenu?.classList.contains('is-open')) closeMobileMenu();
        else openMobileMenu();
      }, { signal: controller.signal });
      mobileMenu?.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', closeMobileMenu, { signal: controller.signal });
      });
      searchToggle?.addEventListener('click', () => {
        if (!searchPanel?.classList.contains('is-open')) {
          openSearch();
        } else if (searchInput?.value.trim()) {
          searchForm?.requestSubmit();
        } else {
          closeSearch();
        }
      }, { signal: controller.signal });
      cartToggle?.addEventListener('click', () => {
        if (cartPopover?.classList.contains('is-open')) closeCart();
        else openCart();
      }, { signal: controller.signal });
      window.addEventListener('mj:cart-updated', (event) => {
        const currentReferenceTotal = Number(cartPopover?.dataset.referenceTotal) || 0;
        const addedReferencePrice = Number(event.detail?.referenceUnitPrice) || 0;
        renderCart(event.detail?.cart, currentReferenceTotal + addedReferencePrice);
        openCart();
      }, { signal: controller.signal });
      window.addEventListener('mj:cart-impact', openCart, { signal: controller.signal });
      searchPanel?.addEventListener('transitionend', (event) => {
        if (event.propertyName === 'clip-path') finishSearchClose();
      }, { signal: controller.signal });
      searchForm?.addEventListener('submit', (event) => {
        if (!searchInput?.value.trim()) {
          event.preventDefault();
          window.MJPageTransition?.start();
          window.location.assign(searchForm.dataset.searchUrl);
          return;
        }
        window.MJPageTransition?.start();
      }, { signal: controller.signal });
      document.addEventListener('pointerdown', (event) => {
        if (language && !language.contains(event.target)) closeLanguage();
        if (mobileMenu?.classList.contains('is-open') && !header.contains(event.target)) closeMobileMenu();
        if (searchPanel?.classList.contains('is-open') && !searchShell?.contains(event.target)) closeSearch();
        if (cartPopover?.classList.contains('is-open') && !cartShell?.contains(event.target)) closeCart();
      }, { signal: controller.signal });
      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        closeLanguage();
        closeMobileMenu();
        if (searchPanel?.classList.contains('is-open')) closeSearch();
        closeCart();
      }, { signal: controller.signal });
      addHomepageInputListener('wheel', (event) => {
        if (!cartPopover?.classList.contains('is-open')) return;
        if (!cartPopover.contains(event.target)) {
          closeCart();
          return;
        }
        if (!cartItems || cartItems.scrollHeight <= cartItems.clientHeight) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        const wheelScale = event.deltaMode === 1
          ? 16
          : event.deltaMode === 2
            ? cartItems.clientHeight
            : 1;
        cartItems.scrollTop += event.deltaY * wheelScale;
      }, { capture: true, passive: false });
      window.addEventListener('mousedown', (event) => {
        if (event.button !== 0 || !isScrollbarEdge(event) || isScrollbarArrow(event)) return;
        window.clearTimeout(scrollbarReleaseTimer);
        setScrollbarDrag(true);
      }, { capture: true, passive: true, signal: controller.signal });
      window.addEventListener('mouseup', () => {
        if (!scrollbarDragActive) return;
        window.clearTimeout(scrollbarReleaseTimer);
        scrollbarReleaseTimer = window.setTimeout(() => {
          setScrollbarDrag(false);
          reconcileNativePosition();
        }, 80);
      }, { capture: true, passive: true, signal: controller.signal });
      window.addEventListener('blur', () => {
        if (!scrollbarDragActive) return;
        setScrollbarDrag(false);
        reconcileNativePosition();
      }, { signal: controller.signal });
      window.addEventListener('resize', () => {
        invalidateSectionMetrics();
        if (window.innerWidth > 749) closeMobileMenu();
        update();
      }, { passive: true, signal: controller.signal });
      backToTop?.addEventListener('click', () => {
        const metrics = getSectionMetrics();
        if (!metrics) return;
        returnToTop(metrics);
      }, { signal: controller.signal });
      cta?.addEventListener('click', (event) => {
        const metrics = getSectionMetrics();
        if (!metrics) return;
        event.preventDefault();
        if (reducedMotion.matches) {
          setProductsOperable(true);
          jumpToScrollTop(metrics.productsStart);
          update();
          return;
        }
        enterProductsFromCta(metrics);
      }, { signal: controller.signal });

      const handleWheel = (event) => {
        const direction = Math.sign(event.deltaY);
        if (direction > 0 && isAtPageBottom()) nudgeBackToTop();
        if (topReturnActive) {
          if (event.cancelable) event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        if (document.documentElement.classList.contains('mj-products-video-playing')) {
          if (direction < 0) return;
          if (event.cancelable) event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        if (scrollbarDragActive) return;
        if (direction > 0 && returningFromProducts) {
          if (window.scrollY >= returnStartScrollTop - 2) {
            setReturningFromProducts(false);
          }
        }
        if (sectionTransitioning) {
          if (direction && sectionDirection && direction !== sectionDirection) {
            cancelSectionTransition();
            return;
          }
          if (event.cancelable) event.preventDefault();
          return;
        }
        if (direction < 0 && productsVisited) {
          const metrics = getSectionMetrics();
          const productAtStart = document.documentElement.classList.contains('mj-products-at-start');
          if (metrics && productAtStart && window.scrollY >= metrics.productsStart - 2 && window.scrollY <= metrics.productsEnd + 2) {
            setReturningFromProducts(true);
          }
        }
      };

      const ready = () => {
        duration = Math.max(0, video.duration - (1 / heroScrubFrameRate));
        if (!video.paused) video.pause();
        if (returningFromProducts || topReturnActive) video.currentTime = 0;
        if (nativePositionRestoreActive && window.scrollY >= (getSectionMetrics()?.productsTop ?? Number.POSITIVE_INFINITY) - 2) targetTime = duration;
        update();
      };

      const navigationEntry = performance.getEntriesByType('navigation')[0];
      const isReturnNavigation = navigationEntry?.type === 'reload' || navigationEntry?.type === 'back_forward';
      try {
        const saved = JSON.parse(sessionStorage.getItem('mj-home-scroll-position') || 'null');
        const newsletter = JSON.parse(sessionStorage.getItem('mj-home-newsletter-return') || 'null');
        const fresh = (entry) => entry && Number.isFinite(entry.y) && Date.now() - entry.at < 30 * 60 * 1000;
        if (fresh(newsletter)) restoreTop = newsletter.y;
        else if (isReturnNavigation && fresh(saved)) restoreTop = saved.y;
        if (fresh(newsletter)) sessionStorage.removeItem('mj-home-newsletter-return');
      } catch (error) {}
      nativePositionRestoreActive = restoreTop !== null;
      if (nativePositionRestoreActive) document.documentElement.classList.add('mj-restoring-position');
      if ('scrollRestoration' in history) history.scrollRestoration = restoreTop === null ? 'auto' : 'manual';

      window.addEventListener('pagehide', () => {
        try {
          sessionStorage.setItem('mj-home-scroll-position', JSON.stringify({ y: window.scrollY, at: Date.now() }));
        } catch (error) {}
      }, { signal: controller.signal });

      const getNativeRestoreTop = () => {
        const scrollingElement = document.scrollingElement || document.documentElement;
        const maxTop = Math.max(0, scrollingElement.scrollHeight - window.innerHeight);
        return clamp(Number(restoreTop) || 0, 0, maxTop);
      };

      const applyNativePositionRestore = () => {
        if (restoreTop === null) return;
        const targetTop = getNativeRestoreTop();
        if (Math.abs(window.scrollY - targetTop) > 1) {
          window.scrollTo({ left: window.scrollX, top: targetTop, behavior: 'instant' });
        }
        sectionTransitioning = false;
        reconcileNativePosition();
      };

      const releaseNativePositionRestore = () => {
        if (!nativePositionRestoreActive) return;
        applyNativePositionRestore();
        nativePositionRestoreActive = false;
        restoreTop = null;
        document.documentElement.classList.remove('mj-restoring-position');
        if ('scrollRestoration' in history) history.scrollRestoration = 'auto';
        window.MahjverseHomeScroll?.request();
      };

      const restoreNativePosition = () => {
        if (restoreTop !== null) {
          nativePositionRestoreActive = true;
          document.documentElement.classList.add('mj-restoring-position');
          applyNativePositionRestore();
          window.clearTimeout(nativePositionRestoreTimer);
          nativePositionRestoreTimer = window.setTimeout(releaseNativePositionRestore, 1400);
        } else {
          update();
        }
      };
      const schedulePositionRestore = () => {
        requestAnimationFrame(() => requestAnimationFrame(restoreNativePosition));
      };
      window.addEventListener('pageshow', schedulePositionRestore, { signal: controller.signal });
      window.addEventListener('load', schedulePositionRestore, { once: true, signal: controller.signal });
      schedulePositionRestore();

      video.addEventListener('loadedmetadata', ready, { signal: controller.signal });
      video.addEventListener('loadeddata', revealVideoFrame, { once: true, signal: controller.signal });
      video.addEventListener('seeked', () => {
        revealVideoFrame();
        if (!raf && Math.abs(targetTime - video.currentTime) > 0.002) {
          raf = requestAnimationFrame(render);
        }
      }, { signal: controller.signal });
      reconcileNativePosition = () => {
        const metrics = getSectionMetrics();
        if (!metrics) return;
        const currentTop = window.scrollY;
        syncHeroJourney(currentTop, metrics);
        heroCovered = currentTop >= metrics.productsTop - 2;
        if (heroCovered && !returningFromProducts) targetTime = duration;
        sectionTransitioning = false;
        syncProductEntryState(false);
        setProductsOperable(currentTop >= metrics.productsStart - 2 && currentTop <= metrics.productsEnd + 2);
        update();
      };

      if (nativePositionRestoreActive) {
        window.addEventListener('scroll', () => {
          if (nativePositionRestoreActive && !scrollbarDragActive) applyNativePositionRestore();
        }, { passive: true, signal: controller.signal });
      }

      const refreshHero = (renderNow) => {
        if (!renderNow) {
          update();
          return;
        }
        if (raf) cancelAnimationFrame(raf);
        needsMeasure = true;
        render();
      };

      const onHomeScroll = (renderNow = false) => {
        if (nativePositionRestoreActive || document.documentElement.classList.contains('mj-restoring-position')) return;
        if (topReturnActive) {
          refreshHero(renderNow);
          return;
        }
        if (scrollbarDragActive) {
          const metrics = getSectionMetrics();
          if (metrics) {
            syncHeroJourney(window.scrollY, metrics);
            heroCovered = window.scrollY >= metrics.productsTop - 2;
            if (heroCovered && !returningFromProducts) targetTime = duration;
          }
          refreshHero(renderNow);
          return;
        }
        const nextScrollTop = window.scrollY;
        const metrics = getSectionMetrics();
        syncHeroJourney(nextScrollTop, metrics);
        heroCovered = Boolean(metrics && nextScrollTop >= metrics.productsTop - 2);
        setProductsOperable(Boolean(metrics && nextScrollTop >= metrics.productsStart - 2 && nextScrollTop <= metrics.productsEnd + 2));
        refreshHero(renderNow);
      };
      if (window.MahjverseHomeScroll) {
        window.MahjverseHomeScroll.subscribe(() => onHomeScroll(true), { signal: controller.signal });
      } else {
        window.addEventListener('scroll', onHomeScroll, { passive: true, signal: controller.signal });
      }
      if ('ResizeObserver' in window) {
        const products = document.querySelector('#mahjverse-products');
        sectionResizeObserver = new ResizeObserver(() => {
          invalidateSectionMetrics();
          update();
        });
        sectionResizeObserver.observe(root);
        if (products) sectionResizeObserver.observe(products);
      }
      addHomepageInputListener('wheel', handleWheel, { capture: true, passive: false });
      addHomepageInputListener('touchstart', (event) => {
        bottomNudgeTouchY = event.touches[0]?.clientY || 0;
      }, { passive: true });
      addHomepageInputListener('touchmove', (event) => {
        const currentY = event.touches[0]?.clientY || 0;
        if (bottomNudgeTouchY - currentY > 12 && isAtPageBottom()) {
          nudgeBackToTop();
          bottomNudgeTouchY = currentY;
        }
      }, { passive: true });
      reducedMotion.addEventListener?.('change', () => {
        clearHeaderFlip();
        update();
      }, { signal: controller.signal });
      document.addEventListener('visibilitychange', () => {
        if (!document.hidden && video.readyState < 2) video.load();
      }, { signal: controller.signal });
      document.addEventListener('shopify:section:unload', (event) => {
        if (event.target === root || event.target.contains(root)) {
          controller.abort();
          document.documentElement.classList.remove('mj-products-entering');
          document.documentElement.classList.remove('mj-products-operable');
          document.documentElement.classList.remove('mj-top-returning');
          document.documentElement.classList.remove('mj-restoring-position');
          if (raf) cancelAnimationFrame(raf);
          if (sectionFrame) cancelAnimationFrame(sectionFrame);
          window.clearTimeout(nativePositionRestoreTimer);
          if (scrollbarReleaseTimer) window.clearTimeout(scrollbarReleaseTimer);
          if (searchCloseTimer) window.clearTimeout(searchCloseTimer);
          sectionResizeObserver?.disconnect();
          popoverResizeObserver.disconnect();
          document.documentElement.classList.remove('mj-scrollbar-dragging');
          document.documentElement.classList.remove('mj-low-power');
          if (objectUrl) URL.revokeObjectURL(objectUrl);
        }
      }, { signal: controller.signal });

      const desktopParts = video.dataset.desktopParts.split('|').filter(Boolean);
      const mobileParts = video.dataset.mobileParts.split('|').filter(Boolean);
      const lowPowerParts = video.dataset.lowPowerParts.split('|').filter(Boolean);
      const partUrls = mobileLayout.matches ? mobileParts : lowPowerDevice ? lowPowerParts : desktopParts;
      const loadVideoParts = async () => {
        if (!lowPowerDevice) {
          const responses = await Promise.all(partUrls.map((url) => fetch(url, { cache: 'force-cache', signal: controller.signal })));
          if (responses.some((response) => !response.ok)) throw new Error('Video preload failed');
          return Promise.all(responses.map((response) => response.arrayBuffer()));
        }
        const parts = [];
        for (const url of partUrls) {
          const response = await fetch(url, { cache: 'force-cache', signal: controller.signal });
          if (!response.ok) throw new Error('Video preload failed');
          parts.push(await response.arrayBuffer());
        }
        return parts;
      };

      loadVideoParts()
        .then((parts) => {
          if (controller.signal.aborted) return;
          objectUrl = URL.createObjectURL(new Blob(parts, { type: 'video/mp4' }));
          video.src = objectUrl;
          video.load();
        })
        .catch((error) => {
          if (error.name !== 'AbortError') root.classList.remove('is-video-ready');
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mahjverse-product-grid"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
    const mobileProducts = window.matchMedia('(max-width: 749px)');
    const PRODUCT_START_WHEEL_DISTANCE = 4 * 120;
    const HERO_RETURN_WHEEL_DISTANCE = 6 * 120;

    document.querySelectorAll('.mj-product-panel').forEach((panel) => {
      if (mobileProducts.matches) return;
      const visual = panel.querySelector('.mj-product-panel__visual');
      let closeTimer = 0;
      const cancelClose = () => {
        if (closeTimer) window.clearTimeout(closeTimer);
        closeTimer = 0;
      };
      const close = (afterCartAnimation = false) => {
        cancelClose();
        if (panel.classList.contains('is-cart-animating')) {
          if (afterCartAnimation) panel.classList.add('is-cart-close-pending');
          return;
        }
        panel.classList.remove('is-cart-close-pending');
        panel.classList.remove('is-product-open');
      };
      const queueClose = () => {
        cancelClose();
        closeTimer = window.setTimeout(close, 110);
      };
      visual?.addEventListener('pointerenter', () => {
        cancelClose();
        panel.classList.remove('is-cart-close-pending');
        panel.classList.add('is-product-open');
      });
      panel.addEventListener('pointermove', (event) => {
        if (event.target.closest('.mj-product-panel__visual, .mj-product-panel__drawer')) {
          cancelClose();
          panel.classList.remove('is-cart-close-pending');
        }
        else if (panel.classList.contains('is-product-open')) queueClose();
      });
      panel.addEventListener('pointerleave', () => close(true));
      panel.addEventListener('focusout', () => {
        requestAnimationFrame(() => {
          if (!panel.contains(document.activeElement)) close();
        });
      });
    });

    const readCartCount = () => {
      const badge = document.querySelector('[data-cart-count]');
      return Number.parseInt(badge?.dataset.count || badge?.textContent, 10) || 0;
    };

    const updateCartCount = (count) => {
      const target = document.querySelector('[data-cart-target]');
      const badge = target?.querySelector('[data-cart-count]');
      if (!target || !badge) return;
      const normalizedCount = Math.max(0, Number.parseInt(count, 10) || 0);
      const previousCount = readCartCount();
      target.classList.toggle('has-items', normalizedCount > 0);
      badge.dataset.count = String(normalizedCount);
      if (previousCount === normalizedCount) return;
      const rollToken = `${normalizedCount}-${performance.now()}`;
      badge.dataset.rollToken = rollToken;
      badge.classList.remove('is-rolling');
      badge.classList.toggle('is-empty', normalizedCount === 0);
      badge.style.minWidth = `calc(${String(normalizedCount).length}ch + 5px)`;
      badge.innerHTML = `<span class="mj-hero__cart-count-old">${previousCount}</span><span class="mj-hero__cart-count-new">${normalizedCount}</span>`;
      requestAnimationFrame(() => badge.classList.add('is-rolling'));
      target.classList.remove('is-receiving');
      void target.offsetWidth;
      target.classList.add('is-receiving');
      window.setTimeout(() => {
        if (badge.dataset.rollToken !== rollToken) return;
        target.classList.remove('is-receiving');
        badge.classList.remove('is-rolling');
        badge.textContent = String(normalizedCount);
      }, 560);
    };

    const flyToCart = async (button) => {
      const panel = button.closest('.mj-product-panel');
      panel?.classList.add('is-product-open');
      panel?.classList.remove('is-cart-close-pending');
      panel?.classList.add('is-cart-animating');
      const source = button.querySelector('.mj-product-panel__add-icon');
      await window.MJCartFlight?.flyFrom(source || button);
      panel?.classList.add('is-product-open');
    };

    const waitForDuration = (duration) => new Promise((resolve) => window.setTimeout(resolve, duration));

    const runAddButtonFeedback = async (button, taskPromise) => {
      const addLabel = button.dataset.addLabel || 'ADD';
      const waitLabel = button.dataset.waitLabel || 'WAIT';
      const startedAt = performance.now();
      button.setAttribute('aria-label', waitLabel);
      button.setAttribute('aria-busy', 'true');
      button.classList.remove('is-success');
      button.classList.add('is-loading');

      try {
        const taskResult = await taskPromise;
        await waitForDuration(Math.max(0, 180 - (performance.now() - startedAt)));
        button.setAttribute('aria-label', addLabel);
        button.removeAttribute('aria-busy');
        button.classList.remove('is-loading');
        button.classList.add('is-success');
        await waitForDuration(280);
        button.classList.remove('is-success');
        return taskResult;
      } catch (error) {
        button.setAttribute('aria-label', addLabel);
        button.removeAttribute('aria-busy');
        button.classList.remove('is-loading', 'is-success');
        throw error;
      }
    };

    document.querySelectorAll('[data-product-form]').forEach((form) => {
      if (form.dataset.cartReady === 'true') return;
      form.dataset.cartReady = 'true';
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        const button = form.querySelector('[data-add-button]');
        if (!button || button.disabled || button.classList.contains('is-loading')) return;
        button.disabled = true;
        const previousCount = readCartCount();
        const referenceUnitPrice = Number(form.dataset.referenceUnitPrice) || 0;
        const addLabel = button.dataset.addLabel || 'ADD';
        const panel = button.closest('.mj-product-panel');
        panel?.classList.remove('is-cart-close-pending');
        panel?.classList.add('is-product-open', 'is-cart-animating');
        let completed = false;
        try {
          const rootPath = window.Shopify?.routes?.root || '/';
          const variantId = form.querySelector('input[name="id"]:checked, input[name="id"][type="hidden"]')?.value;
          if (!variantId) throw new Error('Missing variant');
          const addTask = fetch(`${rootPath}cart/add.js`, {
            method: 'POST',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
          }).then(async (response) => {
            if (!response.ok) throw new Error('Cart add failed');
            return response.json();
          });
          const cartSyncTask = addTask.then(async () => {
            const readCart = async () => {
              const response = await fetch(`${rootPath}cart.js`, {
                cache: 'no-store',
                credentials: 'same-origin',
                headers: { Accept: 'application/json' }
              });
              if (!response.ok) throw new Error('Cart read failed');
              return response.json();
            };
            try {
              return await readCart();
            } catch (firstError) {
              await new Promise((resolve) => window.setTimeout(resolve, 80));
              try {
                return await readCart();
              } catch (secondError) {
                return null;
              }
            }
          }).catch(() => null);
          const flightTask = flyToCart(button);
          await runAddButtonFeedback(button, addTask);
          button.disabled = false;
          updateCartCount(previousCount + 1);
          window.dispatchEvent(new CustomEvent('mj:cart-impact'));
          cartSyncTask.then((cart) => {
            if (!cart) return;
            window.dispatchEvent(new CustomEvent('mj:cart-updated', {
              detail: { cart, referenceUnitPrice }
            }));
          });
          completed = true;
          await flightTask;
        } catch (error) {
          button.setAttribute('aria-label', addLabel);
          button.removeAttribute('aria-busy');
          button.classList.remove('is-loading', 'is-success');

        } finally {
          const closePending = panel?.classList.contains('is-cart-close-pending');
          panel?.classList.remove('is-cart-animating');
          panel?.classList.remove('is-cart-close-pending');
          if (closePending) {
            panel.classList.remove('is-product-open');
          } else {
            panel?.classList.add('is-product-open');
          }
          if (!completed) button.disabled = false;
        }
      });
    });

    document.querySelectorAll('[data-products-scroll]').forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      const track = root.querySelector('[data-products-track]');
      if (!track) return;
      const stage = root.querySelector('.mj-products__stage');
      const transition = root.querySelector('[data-products-transition]');
      const transitionVideo = root.querySelector('[data-products-transition-video]');
      const gate = root.querySelector('[data-products-gate]');
      const positionLabel = root.querySelector('[data-products-position]');
      const totalLabel = root.querySelector('[data-products-total]');
      const progressBar = root.querySelector('[data-products-progress]');
      const categorySection = document.querySelector('[data-category-section]');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const mobileLayout = window.matchMedia('(max-width: 749px)');
      const controller = new AbortController();
      const onHomeEvent = (name, listener) => {
        if (window.MahjverseHomeScroll) {
          window.MahjverseHomeScroll.on(name, listener, { signal: controller.signal });
        } else {
          window.addEventListener(`mj:${name}`, listener, { signal: controller.signal });
        }
      };
      let frame = 0;
      let mediaLoadToken = 0;
      let mediaAbort = null;
      let mediaObserver = null;
      let mediaObjectUrl = '';
      let mediaReadyPromise = Promise.resolve();
      let gestureAmount = 0;
      let gateIdleTimer = 0;
      let gateAnimationFrame = 0;
      let gateAnimationTime = 0;
      let gateVisualProgress = 0;
      let gateTargetProgress = 0;
      let transitionRunning = false;
      let transitionDirection = 0;
      let transitionRunToken = 0;
      let transitionFinishTimer = 0;
      let transitionProgressFrame = 0;
      let transitionScrollFrame = 0;
      let transitionOwnedScrollY = null;
      let transitionFrozenTrackX = '';
      let boundaryReleased = false;
      let boundaryGateDirection = 0;
      let boundaryGateDistance = 0;
      let lastNativeY=window.scrollY;
      let touchStartX = 0;
      let touchStartY = 0;
      let touchTracking = false;
      let cachedScrollBounds = null;
      let cachedHorizontalOverflow = null;
      let sectionResizeObserver = null;

      const ensureTransitionMedia = () => {
        if (!transitionVideo || reducedMotion.matches) return;
        const partList = mobileLayout.matches ? transitionVideo.dataset.mobileParts : transitionVideo.dataset.desktopParts;
        const poster = mobileLayout.matches ? transitionVideo.dataset.mobilePoster : transitionVideo.dataset.desktopPoster;
        if (!partList) return;
        if (transitionVideo.dataset.activeParts === partList) return mediaReadyPromise;
        const parts = partList.split('|').filter(Boolean);
        if (!parts.length) return;
        const loadToken = ++mediaLoadToken;
        mediaAbort?.abort();
        mediaAbort = new AbortController();
        transitionVideo.pause();
        transitionVideo.dataset.activeParts = partList;
        transitionVideo.poster = poster || '';
        mediaReadyPromise = (async () => {
          try {
          const buffers = await Promise.all(parts.map(async (url) => {
            const response = await fetch(url, { signal: mediaAbort.signal, credentials: 'same-origin' });
            if (!response.ok) throw new Error('Transition video part failed');
            return response.arrayBuffer();
          }));
          if (loadToken !== mediaLoadToken) return;
          if (mediaObjectUrl) URL.revokeObjectURL(mediaObjectUrl);
          mediaObjectUrl = URL.createObjectURL(new Blob(buffers, { type: 'video/mp4' }));
          transitionVideo.src = mediaObjectUrl;
          transitionVideo.preload = 'auto';
          transitionVideo.load();
          await new Promise((resolve, reject) => {
            if (transitionVideo.readyState >= 2) {
              resolve();
              return;
            }
            let readyTimer = 0;
            const cleanup = () => {
              window.clearTimeout(readyTimer);
              transitionVideo.removeEventListener('loadeddata', handleReady);
              transitionVideo.removeEventListener('error', handleError);
            };
            const handleReady = () => {
              cleanup();
              resolve();
            };
            const handleError = () => {
              cleanup();
              reject(new Error('Transition video decode failed'));
            };
            transitionVideo.addEventListener('loadeddata', handleReady, { once: true });
            transitionVideo.addEventListener('error', handleError, { once: true });
            readyTimer = window.setTimeout(handleError, 4000);
          });
          } catch (error) {
            if (error?.name === 'AbortError') return;
            transitionVideo.dataset.activeParts = '';
          }
        })();
        return mediaReadyPromise;
      };

      const prepareTransitionMedia = () => {
        if (reducedMotion.matches) return;
        ensureTransitionMedia();
      };

      const setTransitionPlaying = (playing) => {
        transition?.classList.toggle('is-playing', playing);
        document.documentElement.classList.toggle('mj-products-video-playing', playing);
        if (!playing) {
          transition?.classList.remove('is-priming');
          transition?.style.removeProperty('transform');
        }
      };

      const resetTransitionMedia = () => {
        transitionOwnedScrollY = null;
        setTransitionPlaying(false);
        if (!transitionVideo) {
          boundaryReleased = false;
          return;
        }
        transitionVideo.pause();
        try { transitionVideo.currentTime = 0; } catch (error) {}
        transitionVideo.playbackRate = 1;
        boundaryReleased = false;
      };

      const isScrollbarDragging = () => document.documentElement.classList.contains('mj-scrollbar-dragging');
      const isGlobalTopReturn = () => document.documentElement.classList.contains('mj-top-returning');
      const isNativePositionRestoring = () => document.documentElement.classList.contains('mj-restoring-position');

      const setGateBoundaryLock = (active) => {
        document.documentElement.classList.toggle('mj-products-gate-locked', Boolean(active) && !mobileLayout.matches);
      };

      const setProductStartMarker = (atStart) => {
        if (mobileLayout.matches) {
          document.documentElement.classList.remove('mj-products-at-start');
          return;
        }
        document.documentElement.classList.toggle('mj-products-at-start', Boolean(atStart));
      };

      const resetProductBoundaryGate = () => {
        boundaryGateDirection = 0;
        boundaryGateDistance = 0;
      };

      const invalidateGeometry = () => {
        cachedScrollBounds = null;
        cachedHorizontalOverflow = null;
      };

      const cancelSectionTransition = () => {
        transitionRunToken += 1;
        mediaAbort?.abort();
        if (transitionProgressFrame) cancelAnimationFrame(transitionProgressFrame);
        if (transitionScrollFrame) cancelAnimationFrame(transitionScrollFrame);
        transitionProgressFrame = 0;
        transitionScrollFrame = 0;
        window.clearTimeout(transitionFinishTimer);
        transitionFinishTimer = 0;
        transitionVideo?.pause();
        if (transitionVideo) transitionVideo.playbackRate = 1;
        setTransitionPlaying(false);
        transition?.classList.remove('is-opening', 'is-open');
        transition?.style.removeProperty('--mj-transition-inset');
        transitionRunning = false;
        transitionDirection = 0;
        transitionOwnedScrollY = null;
        transitionFrozenTrackX = '';
        touchTracking = false;
        resetProductBoundaryGate();
        setGateBoundaryLock(false);
        resetGateCue();
      };
      const cancelSectionTransitionForScrollbar = cancelSectionTransition;

      const resetForGlobalTopReturn = () => {
        cancelSectionTransitionForScrollbar();
        root.classList.remove('is-transition-complete');
        transition?.classList.remove('is-opening', 'is-open');
        transitionFrozenTrackX = '';
        transitionOwnedScrollY = null;
        transitionRunning = false;
        boundaryReleased = false;
        lastNativeY=window.scrollY;
        document.documentElement.classList.remove('mj-products-at-start');
        resetTransitionMedia();
        update();
      };

      const getScrollBounds = (refresh = false) => {
        if (cachedScrollBounds && !refresh) return cachedScrollBounds;
        const top = root.getBoundingClientRect().top + window.scrollY;
        const inset = Math.max(1, Number(root.dataset.scrollInset) || 2);
        const start = Math.ceil(top) + inset;
        const end = Math.max(start, Math.floor(top + root.offsetHeight - window.innerHeight) - inset);
        cachedScrollBounds = { start, end };
        return cachedScrollBounds;
      };

      const getHorizontalOverflow = () => {
        if (Number.isFinite(cachedHorizontalOverflow)) return cachedHorizontalOverflow;
        cachedHorizontalOverflow = Math.max(0, track.scrollWidth - (stage?.clientWidth || window.innerWidth));
        return cachedHorizontalOverflow;
      };

      const holdProductStartBoundary = (event, delta, start) => {
        if (mobileLayout.matches || !delta) return false;
        const currentY = window.scrollY;
        const nextY = currentY + delta;
        const direction = Math.sign(delta);
        const atStart = Math.abs(currentY - start) <= 3;
        const crossingStart = (direction > 0 && currentY < start && nextY >= start)
          || (direction < 0 && currentY > start && nextY <= start);
        if (crossingStart) {
          resetProductBoundaryGate();
          boundaryGateDirection = direction;
          if (event.cancelable) event.preventDefault();
          event.stopImmediatePropagation();
          window.scrollTo({ top: start, left: window.scrollX, behavior: 'auto' });
          lastNativeY = start;
          setGateBoundaryLock(false);
          resetGateCue();
          return true;
        }
        if (boundaryGateDirection && (!atStart || direction !== boundaryGateDirection)) {
          resetProductBoundaryGate();
        }
        if (!atStart) return false;
        if (!boundaryGateDirection) boundaryGateDirection = direction;
        boundaryGateDistance += Math.abs(delta);
        const requiredDistance = direction > 0 ? PRODUCT_START_WHEEL_DISTANCE : HERO_RETURN_WHEEL_DISTANCE;
        if (boundaryGateDistance >= requiredDistance) {
          resetProductBoundaryGate();
          return false;
        }
        if (event.cancelable) event.preventDefault();
        event.stopImmediatePropagation();
        setGateBoundaryLock(false);
        resetGateCue();
        return true;
      };

      const renderGateCue = (progress) => {
        if (!gate) return;
        const normalized = clamp(progress, 0, 1);
        if (mobileLayout.matches) {
          gate.style.setProperty('--mj-gate-shift', `${normalized * 36}vw`);
        } else {
          gate.style.setProperty('--mj-gate-shift', `${normalized * 40}vw`);
        }
        gate.style.setProperty('--mj-gate-opacity', normalized > 0 ? String(.16 + normalized * .76) : '0');
      };

      const animateGateCue = (now) => {
        const elapsed = Math.min(48, Math.max(0, now - gateAnimationTime));
        gateAnimationTime = now;
        const timeConstant = gateTargetProgress > gateVisualProgress ? 52 : 70;
        const blend = 1 - Math.exp(-elapsed / timeConstant);
        gateVisualProgress += (gateTargetProgress - gateVisualProgress) * blend;
        if (Math.abs(gateTargetProgress - gateVisualProgress) <= .001) {
          gateVisualProgress = gateTargetProgress;
          gateAnimationFrame = 0;
          renderGateCue(gateVisualProgress);
          return;
        }
        renderGateCue(gateVisualProgress);
        gateAnimationFrame = requestAnimationFrame(animateGateCue);
      };

      const setGateCue = (progress) => {
        gateTargetProgress = clamp(progress, 0, 1);
        if (gateAnimationFrame) return;
        gateAnimationTime = performance.now();
        gateAnimationFrame = requestAnimationFrame(animateGateCue);
      };

      const resetGateCue = () => {
        window.clearTimeout(gateIdleTimer);
        gateIdleTimer = 0;
        gestureAmount = 0;
        setGateCue(0);
      };

      const releaseProductBoundary = () => {
        if (boundaryReleased) return;
        boundaryReleased = true;
        setGateBoundaryLock(false);
        document.documentElement.classList.remove('mj-products-entering');
      };

      const reconcileScrollbarPosition = () => {
        if (isScrollbarDragging() || mobileLayout.matches) return;
        const { end } = getScrollBounds(true);
        const currentY = window.scrollY;
        const completed = currentY > end;
        cancelSectionTransitionForScrollbar();
        resetTransitionMedia();
        boundaryReleased = completed;
        root.classList.toggle('is-transition-complete', completed);
        lastNativeY = currentY;
        setGateBoundaryLock(false);
        update();
      };

      const syncCategoryTopGap = () => {
        const progressTrack = progressBar?.parentElement;
        if (!categorySection || !progressTrack || !stage) return;
        const { start, end } = getScrollBounds();
        if (window.scrollY < start - 1 || window.scrollY > end + 1) return;
        const progressRect = progressTrack.getBoundingClientRect();
        const stageRect = stage.getBoundingClientRect();
        if (progressRect.bottom <= 0 || progressRect.bottom >= window.innerHeight) return;
        const targetGap = window.innerHeight - progressRect.bottom;
        const existingGap = Math.max(0, stageRect.bottom - progressRect.bottom);
        const productGap = Math.max(0, targetGap - existingGap);
        const gap = `${Math.round(productGap)}px`;
        root.style.setProperty('--mj-category-product-gap', gap);
        categorySection.style.setProperty('--mj-category-product-gap', gap);
      };

      const getCategoryStartY = () => {
        if (!categorySection) return getScrollBounds().end;
        const categoryTop = categorySection.getBoundingClientRect().top + window.scrollY;
        return Math.max(0, Math.ceil(categoryTop));
      };

      const renderTransitionReveal = (progress) => {
        if (!transition) return;
        const inset = (1 - clamp(progress, 0, 1)) * 50;
        transition.style.setProperty('--mj-transition-inset', `${inset}%`);
      };

      const animateTransitionReveal = (runToken) => {
        if (!transition) return;
        if (transitionProgressFrame) cancelAnimationFrame(transitionProgressFrame);
        const startedAt = performance.now();
        const duration = 300;
        renderTransitionReveal(0);
        const step = (now) => {
          if (runToken !== transitionRunToken || !transitionRunning) {
            transitionProgressFrame = 0;
            return;
          }
          const progress = clamp((now - startedAt) / duration, 0, 1);
          const eased = progress * progress * (3 - 2 * progress);
          renderTransitionReveal(eased);
          if (progress < 1) {
            transitionProgressFrame = requestAnimationFrame(step);
            return;
          }
          transitionProgressFrame = 0;
          transition.style.removeProperty('--mj-transition-inset');
        };
        transitionProgressFrame = requestAnimationFrame(step);
      };

      const animateToCategoryStart = (targetY) => {
        releaseProductBoundary();
        const startY = window.scrollY;
        const startedAt = performance.now();
        const duration = 145;
        const step = (now) => {
          const progress = clamp((now - startedAt) / duration, 0, 1);
          const eased = 1 - Math.pow(1 - progress, 4);
          transitionOwnedScrollY = startY + (targetY - startY) * eased;
          window.scrollTo({ top: transitionOwnedScrollY, left: window.scrollX, behavior: 'auto' });
          if (progress < 1) {
            transitionScrollFrame = requestAnimationFrame(step);
            return;
          }
          transitionScrollFrame = 0;
          window.scrollTo({ top: targetY, left: window.scrollX, behavior: 'auto' });
          lastNativeY = targetY;
          root.classList.add('is-transition-complete');
          transition?.classList.remove('is-opening', 'is-open');
          transition?.style.removeProperty('--mj-transition-inset');
          transitionVideo?.pause();
          if (transitionVideo) transitionVideo.playbackRate = 1;
          setTransitionPlaying(false);
          transitionRunning = false;
          transitionDirection = 0;
          transitionOwnedScrollY = null;
          transitionFrozenTrackX = '';
        };
        transitionScrollFrame = requestAnimationFrame(step);
      };

      const startTransition = async () => {
        if (transitionRunning || reducedMotion.matches || isScrollbarDragging() || isGlobalTopReturn() || isNativePositionRestoring()) return;
        const runToken = ++transitionRunToken;
        transitionRunning = true;
        transitionDirection = 1;
        const { end: gateY } = getScrollBounds(true);
        transitionFrozenTrackX = track.style.getPropertyValue('--mj-products-x');
        transition?.classList.remove('is-opening', 'is-open');
        transition?.classList.add('is-priming');
        setTransitionPlaying(true);
        setGateBoundaryLock(true);
        boundaryReleased = false;
        window.clearTimeout(gateIdleTimer);
        gateIdleTimer = 0;
        gestureAmount = 0;
        setGateCue(0);

        transitionOwnedScrollY = gateY;
        if (Math.abs(window.scrollY - gateY) > 1) {
          window.scrollTo({ top: gateY, left: window.scrollX, behavior: 'auto' });
        }
        lastNativeY = gateY;
        syncCategoryTopGap();

        const ready = ensureTransitionMedia();
        if (ready) await ready;
        if (runToken !== transitionRunToken || !transitionRunning || isScrollbarDragging() || isGlobalTopReturn()) return;

        const categoryStartY = getCategoryStartY();
        let advancing = false;
        const advance = () => {
          if (runToken !== transitionRunToken || !transitionRunning || advancing || isGlobalTopReturn()) return;
          advancing = true;
          window.clearTimeout(transitionFinishTimer);
          if (transitionProgressFrame) cancelAnimationFrame(transitionProgressFrame);
          animateToCategoryStart(categoryStartY);
        };

        if (!transitionVideo || transitionVideo.readyState < 2) {
          advance();
          return;
        }

        try { transitionVideo.currentTime = 0; } catch (error) {}
        if (transitionVideo.seeking) {
          await new Promise((resolve) => {
            const finish = () => {
              window.clearTimeout(seekTimer);
              transitionVideo.removeEventListener('seeked', finish);
              transitionVideo.removeEventListener('error', finish);
              resolve();
            };
            const seekTimer = window.setTimeout(finish, 1000);
            transitionVideo.addEventListener('seeked', finish, { once: true });
            transitionVideo.addEventListener('error', finish, { once: true });
          });
        }
        if (runToken !== transitionRunToken || !transitionRunning || isGlobalTopReturn()) return;
        if (transitionVideo.seeking || transitionVideo.currentTime > 0.08) {
          advance();
          return;
        }
        transitionVideo.playbackRate = 1.65;
        transitionVideo.addEventListener('ended', advance, { once: true, signal: controller.signal });
        let framePresented = false;
        const revealFirstFrame = () => {
          if (framePresented || runToken !== transitionRunToken || !transitionRunning || isGlobalTopReturn()) return;
          framePresented = true;
          transition?.classList.remove('is-priming', 'is-open');
          if (transition) {
            transition.classList.add('is-opening');
            transition.style.removeProperty('transform');
            renderTransitionReveal(0);
            transition.classList.add('is-open');
            animateTransitionReveal(runToken);
          }
          const remainingDuration = Number.isFinite(transitionVideo.duration) && transitionVideo.duration > 0
            ? Math.max(0, transitionVideo.duration - transitionVideo.currentTime) / transitionVideo.playbackRate * 1000
            : 300;
          transitionFinishTimer = window.setTimeout(advance, Math.max(380, remainingDuration + 80));
        };
        if ('requestVideoFrameCallback' in transitionVideo) {
          transitionVideo.requestVideoFrameCallback(revealFirstFrame);
        }
        transitionVideo.play().then(() => {
          if ('requestVideoFrameCallback' in transitionVideo) return;
          requestAnimationFrame(() => requestAnimationFrame(revealFirstFrame));
        }).catch(advance);
      };

      const normalizedWheelDelta = (event) => {
        if (event.deltaMode === 1) return event.deltaY * 16;
        if (event.deltaMode === 2) return event.deltaY * window.innerHeight;
        return event.deltaY;
      };

      const productsAreOperable = () => {
        if (isGlobalTopReturn() || isNativePositionRestoring()) return false;

        if (document.documentElement.classList.contains('mj-products-entering')) return false;
        const { start, end } = getScrollBounds();
        return window.scrollY >= start - 4 && window.scrollY <= end + 4;
      };

      const getGateThreshold = () => mobileLayout.matches ? 128 : 640;

      const consumeGateDistance = (delta) => {
        if (delta <= 0 || transitionRunning || isScrollbarDragging()) return;
        setGateBoundaryLock(true);
        const threshold = getGateThreshold();
        gestureAmount += Math.min(Math.abs(delta), threshold);
        setGateCue(clamp(gestureAmount / threshold, .12, 1));
        if (gestureAmount >= threshold) {
          startTransition();
          return;
        }
        window.clearTimeout(gateIdleTimer);
        gateIdleTimer = window.setTimeout(resetGateCue, 180);
      };

      const onWheel = (event) => {
        if (isNativePositionRestoring()) {
          if (event.cancelable) event.preventDefault();
          return;
        }
        if (reducedMotion.matches || isScrollbarDragging() || isGlobalTopReturn()) return;
        const delta = normalizedWheelDelta(event);
        if (transitionRunning) {
          const direction = Math.sign(delta);
          const runningDirection = transitionDirection;
          if (direction && runningDirection && direction !== runningDirection) {
            cancelSectionTransition();
            return;
          }
          if (event.cancelable) event.preventDefault();
          return;
        }
        const { start, end } = getScrollBounds();
        if (holdProductStartBoundary(event, delta, start)) return;
        if (!productsAreOperable()) return;
        if (delta < 0 && window.scrollY <= start + 3) {
          setGateBoundaryLock(false);
          resetGateCue();
          return;
        }
        if (delta <= 0) {
          setGateBoundaryLock(false);
          if (window.scrollY <= end + 3) resetGateCue();
          return;
        }
        if (window.scrollY < end - 1) {
          if (window.scrollY + delta >= end) {
            if (event.cancelable) event.preventDefault();
            const overflowDelta = Math.max(0, delta - (end - window.scrollY));
            setGateBoundaryLock(true);
            window.scrollTo({ top: end, left: window.scrollX, behavior: 'auto' });
            lastNativeY = end;
            consumeGateDistance(overflowDelta);
          }
          return;
        }
        if (event.cancelable) event.preventDefault();
        setGateBoundaryLock(true);
        if (Math.abs(window.scrollY - end) > 1) {
          window.scrollTo({ top: end, left: window.scrollX, behavior: 'auto' });
          lastNativeY = end;
        }
        consumeGateDistance(delta);
      };

      const onWindowScroll = (renderNow = false) => {
        const refresh = () => renderNow ? renderProducts() : update();
        const y = window.scrollY;
        const previous = lastNativeY;
        lastNativeY = y;
        if (document.documentElement.classList.contains('mj-restoring-position')) {
          if (transitionRunning) cancelSectionTransitionForScrollbar();
          if (y > getScrollBounds().end) {
            boundaryReleased = true;
            setGateBoundaryLock(false);
          }
          refresh();
          return;
        }
        if (isScrollbarDragging()) {
          resetProductBoundaryGate();
          setGateBoundaryLock(false);
          refresh();
          return;
        }
        if (
          !isGlobalTopReturn()
          && !transitionRunning
          && !boundaryReleased
          && !root.classList.contains('is-transition-complete')
        ) {
          const { end } = getScrollBounds();
          if (y >= end - 1) setGateBoundaryLock(true);
          if (y > end) {
            const gateDelta = y > previous ? y - Math.max(previous, end) : 0;
            lastNativeY = end;
            window.scrollTo({ top: end, left: window.scrollX, behavior: 'auto' });
            if (gateDelta > 0) consumeGateDistance(gateDelta);
            refresh();
            return;
          }
        }
        if(!isGlobalTopReturn()&&!isScrollbarDragging()&&!transitionRunning){
          const {start,end}=getScrollBounds();
          if(y>=start-3&&y<=end+3){
            if(boundaryReleased || root.classList.contains('is-transition-complete')){
              transitionRunToken += 1;
              if(transitionProgressFrame) cancelAnimationFrame(transitionProgressFrame);
              if(transitionScrollFrame) cancelAnimationFrame(transitionScrollFrame);
              transitionProgressFrame=0;
              transitionScrollFrame=0;
              window.clearTimeout(transitionFinishTimer);
              transitionFinishTimer=0;
              transitionRunning=false;
              transitionOwnedScrollY=null;
              transitionFrozenTrackX='';
              transition?.classList.remove('is-opening','is-open');
              root.classList.remove('is-transition-complete');
              resetTransitionMedia();
              boundaryReleased=false;
            }
          }
        }
        if (
          transitionRunning
          && Number.isFinite(transitionOwnedScrollY)
          && Math.abs(window.scrollY - transitionOwnedScrollY) > 2
        ) {
          window.scrollTo({ top: transitionOwnedScrollY, left: window.scrollX, behavior: 'auto' });
        }
        refresh();
      };

      const onTouchStart = (event) => {
        if (isNativePositionRestoring()) return;
        if (!mobileLayout.matches || !event.touches[0]) return;
        if (!transitionRunning && !productsAreOperable()) return;
        touchStartX = event.touches[0].clientX;
        touchStartY = event.touches[0].clientY;
        touchTracking = true;
        gestureAmount = 0;
      };

      const onTouchMove = (event) => {
        if (isNativePositionRestoring()) {
          event.preventDefault();
          return;
        }
        if (transitionRunning) {
          if (touchTracking && event.touches[0]) {
            const deltaY = touchStartY - event.touches[0].clientY;
            const direction = Math.sign(deltaY);
            const runningDirection = transitionDirection;
            if (direction && runningDirection && direction !== runningDirection) {
              cancelSectionTransition();
              touchTracking = false;
              return;
            }
          }
          event.preventDefault();
          return;
        }
        if (!touchTracking || !event.touches[0]) return;
        const deltaX = event.touches[0].clientX - touchStartX;
        const deltaY = touchStartY - event.touches[0].clientY;
        if (deltaY <= 0 || Math.abs(deltaY) <= Math.abs(deltaX)) return;
        event.preventDefault();
        gestureAmount = deltaY;
        const progress = clamp(gestureAmount / getGateThreshold(), 0, 1);
        setGateCue(progress);
        if (progress >= 1) {
          touchTracking = false;
          startTransition();
        }
      };

      const onTouchEnd = () => {
        if (!touchTracking) return;
        touchTracking = false;
        resetGateCue();
      };

      if (!reducedMotion.matches && 'IntersectionObserver' in window) {
        mediaObserver = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          ensureTransitionMedia();
          mediaObserver.disconnect();
        }, { rootMargin: '80% 0px' });
        mediaObserver.observe(root);
      }

      onHomeEvent('products-ready', prepareTransitionMedia);

      const renderProducts = () => {
        frame = 0;
        const { start, end } = getScrollBounds();
        setProductStartMarker(!mobileLayout.matches && window.scrollY <= start + 3);
        const sectionProgress = clamp((window.scrollY - start) / Math.max(1, end - start), 0, 1);
        const visualProgress = mobileLayout.matches
          ? clamp((stage?.scrollLeft || 0) / Math.max(1, (stage?.scrollWidth || 0) - (stage?.clientWidth || 0)), 0, 1)
          : sectionProgress;
        const panelWidth = track.firstElementChild?.getBoundingClientRect().width || stage?.clientWidth || 1;
        const visiblePanels = mobileLayout.matches ? 1 : Math.max(1, Math.floor((stage?.clientWidth || 0) / panelWidth));
        const productCount = track.children.length;
        const positions = Math.max(1, productCount - visiblePanels + 1);
        if (positionLabel) positionLabel.textContent = String(1 + Math.round(visualProgress * (positions - 1))).padStart(2, '0');
        if (totalLabel) totalLabel.textContent = String(productCount).padStart(2, '0');
        progressBar?.parentElement?.style.setProperty('--mj-products-progress', visualProgress);
        syncCategoryTopGap();
        if (reducedMotion.matches) return;
        if (!mobileLayout.matches && transitionRunning && transitionFrozenTrackX) {
          track.style.setProperty('--mj-products-x', transitionFrozenTrackX);
        } else if (!mobileLayout.matches && document.documentElement.classList.contains('mj-products-entering')) {
          track.style.setProperty('--mj-products-x', '0px');
        } else if (!mobileLayout.matches) {
          const overflow = getHorizontalOverflow();
          track.style.setProperty('--mj-products-x', `${-overflow * sectionProgress}px`);
        }

        if (transition) {
          transition.style.transform = mobileLayout.matches ? `translate3d(${stage?.scrollLeft || 0}px,0,0)` : 'translate3d(0,0,0)';
        }
        if (gate) {
          gate.style.transform = mobileLayout.matches ? `translate3d(${stage?.scrollLeft || 0}px,0,0)` : 'translate3d(0,0,0)';
        }

        if (!transitionRunning && window.scrollY < end - 16) {
          setGateBoundaryLock(false);
          resetGateCue();
          if (root.classList.contains('is-transition-complete')) {
            root.classList.remove('is-transition-complete');
            resetTransitionMedia();
          }
        }
      };

      const update = () => {
        if (!frame) frame = requestAnimationFrame(renderProducts);
      };
      onHomeEvent('top-return-start', resetForGlobalTopReturn);
      onHomeEvent('hero-geometry-changed', invalidateGeometry);
      onHomeEvent('scrollbar-drag-start', () => {
        resetProductBoundaryGate();
        cancelSectionTransitionForScrollbar();
      });
      onHomeEvent('scrollbar-drag-end', reconcileScrollbarPosition);
      const addHomepageInputListener = (type, listener, options) => {
        if (window.MahjverseHomeScroll?.subscribeInput) {
          window.MahjverseHomeScroll.subscribeInput(type, listener, { signal: controller.signal });
          return;
        }
        window.addEventListener(type, listener, { ...options, signal: controller.signal });
      };
      addHomepageInputListener('wheel', onWheel, { passive: false });
      addHomepageInputListener('touchstart', onTouchStart, { passive: true });
      addHomepageInputListener('touchmove', onTouchMove, { passive: false });
      addHomepageInputListener('touchend', onTouchEnd, { passive: true });
      if (window.MahjverseHomeScroll) {
        window.MahjverseHomeScroll.subscribe(() => onWindowScroll(true), { signal: controller.signal });
      } else {
        window.addEventListener('scroll', onWindowScroll, { passive: true, signal: controller.signal });
      }
      window.addEventListener('resize', () => {
        invalidateGeometry();
        update();
      }, { passive: true, signal: controller.signal });
      if ('ResizeObserver' in window) {
        sectionResizeObserver = new ResizeObserver(() => {
          invalidateGeometry();
          update();
        });
        sectionResizeObserver.observe(root);
        sectionResizeObserver.observe(track);
      }
      stage?.addEventListener('scroll', update, { passive: true, signal: controller.signal });
      reducedMotion.addEventListener?.('change', () => {
        if (reducedMotion.matches) resetTransitionMedia();
        update();
      }, { signal: controller.signal });
      mobileLayout.addEventListener?.('change', () => {
        resetProductBoundaryGate();
        document.documentElement.classList.remove('mj-products-at-start');
        setGateBoundaryLock(false);
        if (transitionVideo) {
          mediaAbort?.abort();
          mediaLoadToken += 1;
          if (mediaObjectUrl) URL.revokeObjectURL(mediaObjectUrl);
          mediaObjectUrl = '';
          transitionVideo.removeAttribute('src');
          transitionVideo.removeAttribute('poster');
          transitionVideo.dataset.activeParts = '';
          transitionVideo.load();
          resetTransitionMedia();
          ensureTransitionMedia();
        }
        update();
      }, { signal: controller.signal });
      document.addEventListener('shopify:section:unload', (event) => {
        if (event.target !== root && !event.target.contains(root)) return;
        controller.abort();
        mediaAbort?.abort();
        mediaObserver?.disconnect();
        if (frame) cancelAnimationFrame(frame);
        if (gateAnimationFrame) cancelAnimationFrame(gateAnimationFrame);
        if (transitionProgressFrame) cancelAnimationFrame(transitionProgressFrame);
        if (transitionScrollFrame) cancelAnimationFrame(transitionScrollFrame);
        window.clearTimeout(gateIdleTimer);
        window.clearTimeout(transitionFinishTimer);
        resetProductBoundaryGate();
        setGateBoundaryLock(false);
        document.documentElement.classList.remove('mj-products-at-start');
        transitionVideo?.pause();
        if (mediaObjectUrl) URL.revokeObjectURL(mediaObjectUrl);
        sectionResizeObserver?.disconnect();
      }, { signal: controller.signal });
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
